import { render } from "./PointsAnimation.vue?vue&type=template&id=7a478474&scoped=true"
import script from "./PointsAnimation.vue?vue&type=script&lang=js"
export * from "./PointsAnimation.vue?vue&type=script&lang=js"

import "./PointsAnimation.vue?vue&type=style&index=0&id=7a478474&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a478474"]])

export default __exports__